import store from 'store';
import actions from 'store/actions/auth';

export const getUser = async () => {
  return store().dispatch(actions.getUser());
};
export const getAccount = async (userName) => {
  return store().dispatch(actions.getAccount(userName));
};

export const login = async (payload) => {
  return store().dispatch(actions.login(payload));
};

export const logout = async () => {
  return actions.logout();
};

export const getAccessToken = async (code, grantType, redirect_uri) => {
  return actions.getAccessToken(code, grantType, redirect_uri);
};
export const updatePassword = async (data) => {
  return actions.updatePassword(data);
};
